import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import home from './components/home'
import user from './components/user/user'
import xinxi from './components/user/xinxi'
import about from './components/user/about'
import detail from './components/user/detail'
import index from './components/fpj/index'
import myfp from './components/fpj/myfp'
import fpjdetail from './components/fpj/fpjdetail'
import fpjdetail2 from './components/fpj/fpjdetail2'
import mail from './components/fpj/mail'
import scptfp from './components/fpj/scptfp'
import scdzfp from './components/fpj/scdzfp'
import dzfppz from './components/fpj/dzfppz'
import invoiceCard from './components/card/invoiceCard'
import addCard from './components/card/addCard'
import addFinish1 from './components/card/addFinish1'
import viewCard from './components/card/viewCard'
import store from './vuex/store'
import ajaxFactory from './config/ajax_factory'
import axios from 'axios'
import wx from 'weixin-js-sdk'

Vue.prototype.$ajax = axios;
// Vue.prototype.host = 'http://vpt.dev.vpiaotong.cn'; //  测试环境;
Vue.prototype.host = 'https://fpj.vpiaotong.com' // 正式环境
Vue.prototype.ajaxFactory = ajaxFactory
Vue.filter('dateFilter', function(value, format) {
    var newDate = new Date()
    newDate.setTime(value)
    var date = {
        'M+': newDate.getMonth() + 1,
        'd+': newDate.getDate(),
        'H+': newDate.getHours(),
        'm+': newDate.getMinutes(),
        's+': newDate.getSeconds(),
        'q+': Math.floor((newDate.getMonth() + 3) / 3),
        'S+': newDate.getMilliseconds()
    }
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (newDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in date) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ?
                date[k] : ('00' + date[k]).substr(('' + date[k]).length))
        }
    }
    return format
})
Vue.filter('currencyFilter', function(value, format) {
    if (value && !isNaN(Number(value))) {
        return value.toFixed(format)
    } else {
        return ''
    }
})
Vue.prototype.dateFilter = function(value, format) {
        var newDate = new Date()
        newDate.setTime(value)
        var date = {
            'M+': newDate.getMonth() + 1,
            'd+': newDate.getDate(),
            'H+': newDate.getHours(),
            'm+': newDate.getMinutes(),
            's+': newDate.getSeconds(),
            'q+': Math.floor((newDate.getMonth() + 3) / 3),
            'S+': newDate.getMilliseconds()
        }
        if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (newDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in date) {
            if (new RegExp('(' + k + ')').test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length === 1 ?
                    date[k] : ('00' + date[k]).substr(('' + date[k]).length))
            }
        }
        return format
    }
    // http response 拦截器
Vue.prototype.$ajax.interceptors.response.use(
    response => {
        if (response.data.code === '401') {
            var ua = navigator.userAgent.toLowerCase()
            var isWeixin = ua.indexOf('micromessenger') !== -1
            if (!isWeixin) {
                document.head.innerHTML = '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">'
                document.body.innerHTML = '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>'
            } else {
                wx.closeWindow()
            }
        }
        return response
    },
    error => {
        if (error.response) {
            window.alert('服务器错误:' + error.response.status)
        }
        return Promise.reject(error.response.data) // 返回接口返回的错误信息
    }
)
var url = location.href.split('#')[0]
Vue.prototype.registWx = function(appId, timestamp, nonceStr, signature) {
    console.log('------------------------')
    console.log(appId)
    console.log(timestamp)
    console.log(nonceStr)
    console.log(signature)
    wx.config({
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: ['scanQRCode', 'chooseImage', 'uploadImage', 'getLocalImgData', 'openCard']
    })
}
Vue.prototype.$ajax.post(Vue.prototype.ajaxFactory.get('jsApiTicket'), {}, {
        params: {
            url: url
        }
    }).then(function(response) {
        var ret = response.data
        window.setInterval(Vue.prototype.registWx(ret.appId, ret.timestamp, ret.nonceStr, ret.signature), 500)
    })
    .catch(function(response) {
        console.log(response)
    })
wx.ready(function() {
    console.log('-------------------------------------index页面wx.ready2完成')
})

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: home
    },
    {
        path: '/addCard/',
        component: addCard
    },
    {
        path: '/viewCard/:id',
        component: viewCard
    },
    {
        path: '/addFinish1/:id',
        component: addFinish1
    },
    {
        path: '/invoiceCard/',
        component: invoiceCard
    },
    {
        path: '/user/',
        component: user
    },
    {
        path: '/xinxi/',
        component: xinxi
    },
    {
        path: '/about/',
        component: about
    },
    {
        path: '/detail/',
        component: detail
    },
    {
        path: '/index/',
        component: index
    },
    {
        path: '/myfp/',
        component: myfp
    },
    {
        path: '/fpjdetail/',
        component: fpjdetail
    },
    {
        path: '/fpjdetail/:source/:imgSize/:invoiceQrcode/:invoiceImagePath/:invoiceId/:invoiceKind',
        component: fpjdetail
    },
    {
        path: '/fpjdetail2/:invoiceId',
        component: fpjdetail2
    },
    {
        path: '/mail/:invoiceQrcode/:invoiceQrcode',
        component: mail
    },
    {
        path: '/mail/:invoiceId',
        component: mail
    },
    {
        path: '/scptfp/',
        component: scptfp
    },
    {
        path: '/scptfp/:id',
        component: scptfp
    },
    {
        path: '/scdzfp/',
        component: scdzfp
    },
    {
        path: '/dzfppz/',
        component: dzfppz
    },
    {
        path: '/dzfppz/:id',
        component: dzfppz
    }
]

const router = new VueRouter({
    routes
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app-box')


// WEBPACK FOOTER //
// ./src/main.js